import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginService } from './core/services/login.service';
import { AppMaterialModule } from './shared/material/app-material.module';
import { TokenInterface } from './core/interfaces/auth.interface';
import { SidenavComponent } from './shared/components/sidenav/sidenav.component';
import { TourMatMenuModule, TourService } from 'ngx-ui-tour-md-menu';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    AppMaterialModule,
    CommonModule,
    SidenavComponent,
    TourMatMenuModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.Emulated, // Evita que Material 3 afete os remotes
})
export class AppComponent {
  title = 'login-broadfactor';
  authToken: TokenInterface | null = null;
  showSidenav = true;

  constructor(public loginService: LoginService, public tourService: TourService) {
    this.loginService.authToken.subscribe((authToken) => {
      this.authToken = authToken;
    });
  }
}
